/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Directory_Submit_Check_Own_DraftInputs */

const en_directory_submit_check_own_draft = /** @type {(inputs: Directory_Submit_Check_Own_DraftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You have a draft for ${i?.name}.`)
};

const zh_directory_submit_check_own_draft = /** @type {(inputs: Directory_Submit_Check_Own_DraftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你已有一份 ${i?.name} 的草稿。`)
};

/**
* | output |
* | --- |
* | "You have a draft for {name}." |
*
* @param {Directory_Submit_Check_Own_DraftInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_check_own_draft = /** @type {((inputs: Directory_Submit_Check_Own_DraftInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Check_Own_DraftInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_check_own_draft(inputs)
	return zh_directory_submit_check_own_draft(inputs)
});
export { directory_submit_check_own_draft as "directory.submit.check.own_draft" }